module.exports = __webpack_public_path__ + "images/09-04@2x_7a22542f.png";